import { imgUrl } from "@/api/general";
import React from "react";
import { AbituriyentIdWrapper } from "./style";

function AbituriyentId({ data }) {
  return (
    <AbituriyentIdWrapper>
      <div className="container">

        {/* Hero: rasm + sarlavha/ma'lumot */}
        <div className="hero-section">
          <div className="img-box">
            <img src={imgUrl + data?.img} alt={data?.subtext || "Bakalavriat"} />
            <span className="img-badge">TDTU · Bakalavriat</span>
          </div>

          <div className="info-box">
            <span className="tag">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2.5"
                strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
                <path d="M6 12v5c3 3 9 3 12 0v-5"/>
              </svg>
              Ta'lim dasturi
            </span>

            {data?.subtext && (
              <div className="title-box">
                <h3>{data.subtext}</h3>
              </div>
            )}
            <div className="divider" />
          </div>
        </div>

        {/* To'liq HTML mazmun */}
        {data?.text && (
          <div className="full-content">
            <div
              dangerouslySetInnerHTML={{ __html: data.text }}
            />
          </div>
        )}
      </div>
    </AbituriyentIdWrapper>
  );
}

export default AbituriyentId;
